import { render } from "./ClassificationForm.vue?vue&type=template&id=3f565486"
import script from "./ClassificationForm.vue?vue&type=script&lang=js"
export * from "./ClassificationForm.vue?vue&type=script&lang=js"
script.render = render

export default script